/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'feedback-collector.anonymous': 'Denne feedback indsendes anonymt. Atlassian vil ikke kunne kontakte dig direkte angående denne feedback',
  'feedback-collector.anonymous.title': 'Anonym feedback',
  'feedback-collector.can-be-contacted.label': 'Ja, Atlassian-teams kan kontakte mig for at lære om mine oplevelser med at forbedre Atlassian-produkter og -tjenester. Jeg accepterer <a>Atlassians politik om beskyttelse af personlige oplysninger</a>.',
  'feedback-collector.cancel-button.label': 'Annuller',
  'feedback-collector.default.custom.textarea.label': 'Hvad tænker du på?',
  'feedback-collector.enrol-in-research.label': 'Jeg vil gerne deltage i produktundersøgelser',
  'feedback-collector.feedback-title': 'Del dine meninger',
  'feedback-collector.form.bug.label': 'Beskriv fejlen eller problemet',
  'feedback-collector.form.comment.label': 'Fortæl os, hvad du har på hjerte',
  'feedback-collector.form.empty.label': 'Vælg en mulighed',
  'feedback-collector.form.question.label': 'Hvad vil du gerne vide?',
  'feedback-collector.form.suggestion.label': 'Fortæl os, hvad du gerne så forbedret',
  'feedback-collector.option.bug.label': 'Rapportere en fejl',
  'feedback-collector.option.comment.label': 'Skrive en kommentar',
  'feedback-collector.option.default.label': 'Vælg feedback',
  'feedback-collector.option.default.placeholder': 'Vælg en svarmulighed',
  'feedback-collector.option.question.label': 'Stille et spørgsmål',
  'feedback-collector.option.suggestion.label': 'Foreslå en forbedring',
  'feedback-collector.required.fields.summary': 'Påkrævede felter er markeret med en stjerne',
  'feedback-collector.submit-button.label': 'Send feedback',
  'feedback-collector.success-flag.description': 'Din feedback hjælper os med at forbedre vores produkter.',
  'feedback-collector.success-flag.title': 'Tak!',
  'feedback-collector.summary-placeholder': 'Fortæl os, hvad du har på hjerte',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Giv feedback'
};